// Client-generated ids make creates optimistic without temp-id reconciliation:
// the id the UI renders with is the id the server stores.

export const newConversationId = () => crypto.randomUUID()

/** 22-char base64url share token. */
export function newShareToken() {
  const bytes = new Uint8Array(16)
  crypto.getRandomValues(bytes)
  let binary = ''
  for (const b of bytes) binary += String.fromCharCode(b)
  return btoa(binary).replaceAll('+', '-').replaceAll('/', '_').replace(/=+$/, '')
}

export function shareUrl(token) {
  return `${window.location.origin}/s/${token}`
}
